import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import UserIcon from "../../assets/img/user-icon.svg";
import VectorIcon from "../../assets/img/VectorIcon1.svg";
import { GoPlus } from "react-icons/go";
import { useNavigate } from "react-router-dom";
import { haveValue } from "../../helper/common";
import { toast } from "react-toastify";
import axiosInstance from "../../services/authWrapper";

const FlatmateModal = ({ sharerData, show, onHide, user, _t }) => {
  const navigate = useNavigate();
  const [loadingStates, setLoadingStates] = useState({});

  const goToProfile = (sharer) => {
    if (haveValue(sharer?.sharerId)) {
      navigate(`/profile-property?sharedprofileid=${sharer?.sharerId}`);
    }
    if (haveValue(sharer?.agencySharerId)) {
      {
        navigate(`/profile-property?agencylink=${sharer?.agencySharerId}`);
      }
    }
  };

  const sendShareProfileEmail = async (data) => {
    await axiosInstance
      .post(
        `${process.env.REACT_APP_SERVER_URL}/shared-profile/sendShareProfileEmail`,
        {
          sharerName: data.sharerName,
          sharerEmail: data.sharerEmail,
          tenantId: data.tenantId,
          landlordId: data.landlordId,
        },
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      )
      .then((res) => {})
      .catch((err) => {});
  };

  //Handlers
  const handleClick = async (sharer) => {
    console.log("BUTTON CLICKED", sharer);
    // Set loading state for this sharer
    setLoadingStates((prevState) => ({
      ...prevState,
      [sharer.sharerId]: true,
    }));

    if (haveValue(sharer?.sharerId) || haveValue(sharer?.agencySharerId)) {
      // Navigate to profile
      goToProfile(sharer);
    } else {
      try {
        // Send share profile email
        await sendShareProfileEmail({
          sharerName: sharer.name,
          sharerEmail: sharer.email,
          tenantId: user._id,
          landlordId: localStorage.getItem("saveduserid"),
        });
        toast.success(_t("Invitation link sent successfully"));
      } catch (error) {
        toast.error(error.message);
        console.error("Error sending email:", error);
      }
    }

    // Reset the loading state for this sharer once the operation is complete
    setLoadingStates((prevState) => ({
      ...prevState,
      [sharer.sharerId]: false,
    }));
  };

  return (
    <Modal
      show={show}
      className="metermodal modal-xl modalWidth_set updateSourceModal Flatmodal"
      centered
      onHide={onHide}
    >
      <Modal.Header className="border-0">
        <Modal.Title className="custom-modal-heading w-100">
          <div className="d-flex align-items-center gap-2">
            {_t("flatmates")}
            <p className="docnumber">{user?.sharers?.length ?? 0}</p>
          </div>
          <ClearOutlinedIcon
            className="close-button-modal"
            onClick={onHide}
            style={{ cursor: "pointer" }}
          />
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="flatmate_modal_body">
        {(sharerData ?? []).map((flatmate, index) => (
          <div
            key={index}
            className="earner-info update-source-info flatmate_section d-flex align-items-center justify-content-between gap-2"
          >
            <div className="d-flex align-items-center gap-2">
              <div className="earner-thumbnail-wrapper">
                <img src={UserIcon} alt="User Icon" />
              </div>
              <h4 className="earner-name">
                {flatmate.name} <span>{flatmate.relation}</span>
              </h4>
            </div>

            <div
              className="cursor-pointer"
              onClick={() => handleClick(flatmate)}
            >
              {loadingStates[flatmate.sharerId] ? (
                <div className="inliveBtn">
                  <p>{_t("sending")}</p>
                </div>
              ) : flatmate?.sharerId || flatmate?.agencySharerId ? (
                <div>
                  <img
                    className="Imagerutate ImageSizeSet"
                    src={VectorIcon}
                    alt="Vector Icon"
                  />
                </div>
              ) : haveValue(flatmate?.tenant_id) ? (
                <div className="inliveBtn text-white">
                  <GoPlus className="text-white" /> {_t("invite")}
                </div>
              ) : (
                <div className="inliveBtn text-white">
                  <p>
                    <GoPlus className="text-white" /> {_t("invite")}
                  </p>
                </div>
              )}
            </div>
          </div>
        ))}
      </Modal.Body>
    </Modal>
  );
};

export default FlatmateModal;
